import { localStorageAdapter } from "commons/LocalStorageAdapter/LocalStorageAdapter";

const laAdapter = new localStorageAdapter();
let elem

if(laAdapter.getItem("kids") === "true") {
  elem = document.querySelector(".kids-header")
  if(elem != null) {
   elem.style.display = "flex"
  }
} else {
  elem = document.querySelector(".site-header")
  if(elem != null) {
   elem.style.display = "block"
  }
}
